import { Menu, MenuItem, type SvgIconOwnProps } from '@presov.sk/presov-ui-react';

/* Action menu loosely inspired by iOS quick actions menu. */
const ActionMenu: React.FC<{
  position?: { top: number; left: number };
  items: {
    key: string;
    Icon: React.FC<SvgIconOwnProps>;
    title: React.ReactNode;
    onClick: () => void;
  }[];
  onClose?: () => void;
}> = ({ position, items, onClose }) => {
  return (
    <Menu
      open={!!position}
      onClose={onClose}
      anchorReference='anchorPosition'
      anchorPosition={position}
      sx={{
        '& .MuiList-root': { p: 0 },
        '& .MuiMenuItem-root': {
          // outline from global theme doesn't work well here
          outlineWidth: '0 !important',
          '& .MuiDivider-root': { m: 0 },
        },
      }}
    >
      {items.map(({ key, Icon, title, onClick }) => (
        <MenuItem
          divider
          key={key}
          onClick={() => onClick()}
          sx={{
            p: 1.5,
            borderRadius: 0,
            borderColor: 'blue',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {title}
          <Icon
            sx={{ color: ({ palette }) => palette.text.secondary, ml: 3 }}
          />
        </MenuItem>
      ))}
    </Menu>
  );
};

export default ActionMenu;
